import React, { useState, useCallback,useEffect } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import TextBox from 'devextreme-react/text-box';
import data from "../assets/apiRoutes.json";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import TextArea from 'devextreme-react/text-area';
const panel = [
    {
        ID: 1,
        Title: 'Edit Datasource'
    }
];
const DeleteDataSource = (props) => {
    var accessToken = props.oidc.user.access_token;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id');
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const [dashboardName, setDashboardName] = useState('');
    const [baseQuery, setBaseQuery] = useState('');
    const [selectedItems, setSelectedItems] = useState([panel[0]]);
    const [success, setSuccess] = useState(false);
    const [IsVisible, setIsVisible] = useState(true);
    const [IsDisable, setIsDisable] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };
    const onBaseQueryChange = useCallback(
        (e) => {
            setBaseQuery(e.value);
        },
        [baseQuery],
    );
    const onDashboardNameChange = useCallback(
        (e) => {
            setDashboardName(e.value);
        },
        [dashboardName],
    );
    const mapToDto = () => {
        return {
            rowid: id,
            dashboardName: dashboardName,
            baseQuery: baseQuery,
        };
    };
    const handelReset = async (e) => {
        e.event.stopPropagation();
        setLoadPanelVisible(true);
        try {
            const inputElements = document.querySelectorAll('.dx-texteditor-input');
            inputElements.forEach((inputElement) => {
                inputElement.value = '';
            });
            setBaseQuery('');
            setDashboardName('');
            setError(false);
            setErrorMessage("");
            setSuccess(false);
            setSuccessMessage("");
            setIsDisable(false);
            setIsVisible(true);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setTimeout(hideLoadPanel, 1000);
        }
    }
    const handelSave = async (e) => {
        e.event.stopPropagation();
        setLoadPanelVisible(true);
        if (!dashboardName) {
            setError(true);
            setErrorMessage("Please enter Datasource name:");
            notify(
                {
                    message: "Please enter Datasource name:",
                    width: 100,
                },
                'error',
                3000,
            );
            setTimeout(hideLoadPanel, 1000);
            return;
        }
        if (!baseQuery) {
            setError(true);
            setErrorMessage("Please enter Base Query:");
            notify(
                {
                    message: "Please enter Base Query:",
                    width: 100,
                },
                'error',
                3000,
            );
            setTimeout(hideLoadPanel, 1000);
            return;
        }
        setError(false);
        setErrorMessage("");
        setIsDisable(true);
        try {
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.DB.DeleteDatasource}`, mapToDto()
                , {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
            if (response.data.success) {
                notify(
                    {
                        message: response.data.message,
                        width: 600,
                    },
                    'success',
                    3000,
                );
                setSuccess(true);
                setSuccessMessage(response.data.message);
                setIsVisible(false);
                setIsDisable(false);
            }
            else {
                notify(
                    {
                        message: response.data.message,
                        width: 600,
                    },
                    'error',
                    3000,
                );
                setIsDisable(false);
                setError(true);
                setErrorMessage(response.data.message);
            }
        }
        catch (error) {
            setIsDisable(false);
            setError(true);
            setErrorMessage('Something went wrong');
        }
        finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const GetInfoById = async (id) => {
        try {
            setLoadPanelVisible(true);
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.DB.GetDatasourceById}?id=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            if (responseData.success) {
                setBaseQuery(responseData.data.comment);
                setDashboardName(responseData.data.layoutname);
            } else {
                console.error('Failed to get item detail:', responseData.message);
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    useEffect(() => {
        GetInfoById(id);
    }, []);

    return (
        <div>
            <div className="row" style={{ marginLeft: "2px" }}>
                <div className="col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                    <div id="accordion" >
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={showIndicator}
                            shading={shading}
                            showPane={showPane}
                            hideOnOutsideClick={hideOnOutsideClick}
                        />
                        <AccordionReact
                            dataSource={panel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Delete Dashboard
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton"  onClick={goBack} text="Back" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" disabled={IsDisable} onClick={handelSave} text="Delete" type="default" />
                                </Item>
                            </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <div style={{ height: '541px', overflowY: 'auto' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextBox
                                                className="light-ui-textbox"
                                                labelMode="static"
                                                label="Datasource Name"
                                                defaultValue=""
                                                style={{ width: '100%' }}
                                                value={dashboardName}
                                                valueChangeEvent="keyup"
                                                onValueChanged={onDashboardNameChange}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: '10px' }}>
                                        <div className="col-md-12">
                                            <TextArea
                                                height={400}
                                                labelMode="static"
                                                label="Base Query"
                                                defaultValue=""
                                                value={baseQuery}
                                                valueChangeEvent="keyup"
                                                onValueChanged={onBaseQueryChange}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            id="accordion-container"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DeleteDataSource);